<template>
	<div class="detail-tips">
		<el-dialog  :lock-scroll='false'  :close-on-click-modal="false" :visible.sync="dialogVisible" width="31.25rem" top="15vh"
			:before-close="close">
			<div class="dialog-head flex-sb" slot="title">
				<div>可示范的推广经验</div>
				<div><i class="el-icon-close"></i></div>
			</div>
			<div class="dialog-content">
				<el-form label-position='top' :model="form" :rules="rules" ref="form" label-width="100px"
					class="demo-ruleForm">
					<el-form-item label="标题" prop="title">
						<el-input v-model="form.title"></el-input>
					</el-form-item>
					<el-form-item label="内容" prop="content">
						<el-input resize="none" rows="5" type="textarea" v-model="form.content"></el-input>
					</el-form-item>
					<el-form-item prop="earlier_files">
						<el-upload class="upload-demo" name="upload_file" :action="baseUrl+'audit/upload_file'"
							:on-preview="handlePreview" :on-remove="handleRemove" :headers="headers"
							:before-remove="beforeRemove" :limit="1" :on-exceed="handleExceed"
							:on-success="handleSuccess" :file-list="fileList" accept=".pdf, .doc, .docx, .xls, .xlsx">
							<div class="col-center">
								<el-button type="primary">点击上传佐证材料</el-button>
								<div slot="tip" class="el-upload__tip">
									只能上传 Pdf / Excel / Word文件
									<!-- <div>单个附件大小不能超过10MB</div> -->
								</div>
							</div>
						</el-upload>
					</el-form-item>

				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="close">取消</el-button>
				<el-button type="primary" @click="add">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	// 文件上传获取上传路径
	import {
		baseUrl
	} from '@/common/config.js'
	let urlRes = ''
	urlRes = window.location.protocol + "//" + window.location.host + "/api/"
	if (urlRes.indexOf('localhost') !== -1) {
		urlRes = 'http://10.0.7.202:8484/api/'
	}
	if (baseUrl) {
		urlRes = baseUrl
	}
	export default {
		name: '',
		props: {

		},
		components: {

		},
		data() {
			return {
				baseUrl: urlRes,
				// 预期成果
				options: [{
					value: 1,
					label: "文学"
				}],
				dialogVisible: false,
				list: [],
				form: {
					title: '',
					content: '',
					earlier_files: ''
				},
				rules: {
					title: [{
						required: true,
						message: '请输入标题',
						trigger: 'blur'
					}],
					content: [{
						required: true,
						message: '请输入计划内容',
						trigger: 'blur'
					}],
					// earlier_files: [{
					// 	required: true,
					// 	message: '请上传附件',
					// 	trigger: 'change'
					// }],
				},
				fileList: [],
				headers: {
					Authorization: ''
				},
			}
		},
		created() {
			let token = localStorage.getItem('access_token')
			this.headers.Authorization = "Bearer " + token
		},
		mounted() {

		},
		methods: {
			// 预期成果
			close() {
				this.form = {
					date: '',
					content: '',
					earlier_files: ''
				}
				this.fileList = []
				this.dialogVisible = false
			},
			add() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						this.$emit('result', JSON.parse(JSON.stringify(this.form)))
						this.close()
					} else {
						return false;
					}
				});
			},
			// 附件相关
			handleRemove(file, fileList) {
				this.form.earlier_files = fileList.filter((item) => {
					if ((item.response && item.response.status_code == 200) || (item.url && item.size &&
							item
							.name)) {
						return item
					}
				}).map(item => {
					if (item.url && item.size && item.name) {
						return item
					} else {
						return item.response.data[0]
					}
				})
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(
					`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			handleSuccess(response, file, fileList) {
				this.form.earlier_files = fileList.filter((item) => {
					if ((item.response && item.response.status_code == 200) || (item.url && item.size &&
							item
							.name)) {
						return item
					}
				}).map(item => {
					if (item.url && item.size && item.name) {
						return item
					} else {
						return item.response.data[0]
					}
				})
			},
		}

	}
</script>

<style lang="scss" scoped>
	.el-upload__tip {
		line-height: 1.25rem;
		text-align: left;
		padding-left: 0.625rem;
	}
</style>